/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'moon': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M9.497 10.504a8.385 8.385 0 01-2.353-7.232A7.156 7.156 0 005.11 4.7l-.001.001A7.205 7.205 0 1015.3 14.89v-.001a7.161 7.161 0 001.428-2.032 8.386 8.386 0 01-7.23-2.353zm.707-.708a7.386 7.386 0 01-1.94-7.019c.113-.449-.267-.897-.706-.748a8.205 8.205 0 1010.413 10.413c.149-.438-.299-.818-.748-.706a7.386 7.386 0 01-7.019-1.94z" _fill="#1F222C"/>'
  }
})
